import React, { useState } from 'react';

import PositionFilter from '../Shared/Filters/PositionFilter';
import { isNCAA, isNCAAAllSports, isOSULacrosse } from '../../helpers/helpers';
import { POSITION_LACROSSE, SEASON_FILTER } from '../../config/constants';
import PositionLacrosseFilter from '../Shared/Filters/PositionLacrosseFilter';
import TeamSelectorContainer from '../Shared/Filters/TeamsSelector';
import SimpleSelector from '../Shared/Filters/SimpleSelector';
import { useUserState } from '../../store/hooks';
import { YEARS_FILTER } from '../../config/constants';

export default ({ loadData, teamIdSelected }: { loadData: () => void, teamIdSelected: string }) => {
  const user = useUserState();
  const [showFilter, setShowFilter] = useState(-1);
  const close = () => setShowFilter(-1);
  
  return (
    <div className="head-filters-account-01">

      {isNCAAAllSports(user) && (
        <TeamSelectorContainer
          show={showFilter === 2}
          close={close}
          open={() => setShowFilter(2)}
        />
      )}
      {isOSULacrosse(teamIdSelected) ? (
        <PositionLacrosseFilter
          type={POSITION_LACROSSE}
          show={showFilter === 1}
          close={close}
          open={() => setShowFilter(1)}
        />
      ) : (
        <PositionFilter
          show={showFilter === 1}
          close={close}
          open={() => setShowFilter(1)}
        />
      )}
    </div>
  );
};
